import React from 'react'
import classnames from 'classnames/bind'
import type {
  ShallowTaskWorkflowGroup,
  ShallowTaskWorkflowItemStatus,
  ReoOffer,
} from '@adc/sdk/types'
import * as graph from '@adc/sdk'
import Icon from '../elementals/icon'
import Text from '../elementals/text'
import MilestoneLabel from './MilestoneLabel'
import MilestoneDate from './MilestoneDate'
import MilestonAction from './milestonAction'
// @ts-ignore
import styles from './styles.scss'
import { PopupTooltip } from '../overlays'

const cx = classnames.bind(styles)

type LocalIconProps = {
  color?: 'success' | 'grayMediumLight' | 'grayDark' | string
  iconStyle?: 'solid' | 'regular' | 'light' | 'brand' | undefined
}

const milestoneIconStyles: Record<
  ShallowTaskWorkflowItemStatus,
  LocalIconProps
> = {
  [graph.enums.ShallowTaskWorkflowItemStatus.Complete]: {
    color: 'success',
    iconStyle: 'solid',
  },
  [graph.enums.ShallowTaskWorkflowItemStatus.Ongoing]: {
    color: 'success',
    iconStyle: 'regular',
  },
  [graph.enums.ShallowTaskWorkflowItemStatus.Upcoming]: {
    color: 'grayMediumLight',
    iconStyle: 'regular',
  },
}

const milestoneTextStyles = {
  [graph.enums.ShallowTaskWorkflowItemStatus.Complete]: { color: 'success' },
  [graph.enums.ShallowTaskWorkflowItemStatus.Ongoing]: { color: 'success' },
  [graph.enums.ShallowTaskWorkflowItemStatus.Upcoming]: { color: 'grayDark' },
}
interface WorkGroupDetailsProps {
  group: ShallowTaskWorkflowGroup
  offerWorkflowStatus: String
  closing: ReoOffer
  elmId?: string
}

const WorkflowDetails: React.FC<WorkGroupDetailsProps> = ({
  group,
  offerWorkflowStatus,
  closing,
  elmId = 'workflow_details',
}) => {
  return (
    <div className={cx('group-details')}>
      <div className={cx('group-header', group.status.toLowerCase())}>
        <Icon
          name='check-circle'
          size='large'
          {...milestoneIconStyles[group.status]}
        />
        <Text
          size='large'
          weight='black'
          {...milestoneTextStyles[group.status]}
        >
          {group.label}
        </Text>
      </div>

      <div
        className={cx('milestones-list', {
          complete:
            group.status === graph.enums.ShallowTaskWorkflowItemStatus.Complete,
        })}
      >
        {group.description ? (
          <div
            className={cx('u-mb-3')}
            data-elm-id={`${elmId}_group_description`}
          >
            <Text color='gray' size='tiny'>
              {group.description}{' '}
              {group.tooltip_label ? (
                // @ts-ignore next
                <PopupTooltip
                  hideOnScroll
                  trigger={
                    <Icon name='info-circle' iconStyle='light' size='small' />
                  }
                  content={
                    <Text size='tiny' color='white'>
                      {group.tooltip_label}
                    </Text>
                  }
                  position='top center'
                  on='hover'
                />
              ) : null}
            </Text>
          </div>
        ) : null}
        {group.tasks.map(task => (
          <div key={task.code} className={cx('milestone')}>
            <Icon
              name='check-circle'
              size='large'
              {...(task.status && milestoneIconStyles[task.status])}
            />
            <MilestoneLabel
              milestone={task}
              offerWorkflowStatus={offerWorkflowStatus}
            />
            <div className={cx('milestone-date-action')}>
              <MilestoneDate milestone={task} />
              <MilestonAction milestone={task} closing={closing} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WorkflowDetails
